module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_1_2_2-9c93b8a8a670e249cb92d98f3fb2ad52.webp";